export default {
  init (vue) {
    return {
      sendVerifyCode(data) {
        return vue.$http({
          method: 'POST',
          url: `/wxmp/carrier/sendVerifyCode`,
          data: {
            ...data
          }
        })
      },
      checkMobilePackage(data) {
        return vue.$http({
          method: 'POST',
          url: `/wxmp/carrier/checkMobilePackage`,
          data: data
        })
      },
      addMobilePackage(data) {
        return vue.$http({
          method: 'POST',
          url: `/wxmp/carrier/addMobilePackage`, 
          data: data
        })
      },
      queryOrder(orderId) {
        return vue.$http({
          method: 'GET',
          url: `/wxmp/carrier/queryOrder`, 
          params: {
            orderId: orderId
          }
        })
      }
    }
  }
}